<template>
  <div>
    <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22.5 23H2.5V3H22.5V23ZM3.36958 22.1304H21.6304V3.86958H3.36958V22.1304Z" :fill="color"/>
      <path d="M12.0645 4.73926H4.23828V12.5655H12.0645V4.73926Z" :fill="color"/>
      <path d="M20.7618 4.73926H12.9355V12.5655H20.7618V4.73926Z" :fill="color"/>
      <path d="M20.7618 13.4351H12.9355V21.2613H20.7618V13.4351Z" :fill="color"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'IconSvgSnmmiClinicalPractice',
  props: {
    color: {
      type: String,
      default: '#000000',
    },
    size: {
      type: Number,
      default: null,
    },
  },
  computed: {
    iconSize() {
      return this.size ? `${this.size}px` : '44px'
    },
  },
}
</script>

<style scoped></style>